import { Box, Button, Dialog, Typography } from '@mui/material';
// Assets
import { ReactComponent as GeneralAlertImg } from 'assets/AlertDialogImg.svg';
import './AlertDialog.css';

const AlertDialog = ({ isOpen = false, title = '', description = '', buttonText = 'OK', onButtonClick = () => {} }) => {
    return (
        <Dialog open={isOpen} fullWidth maxWidth="sm">
            <Box className="alert-dialog">
                <Box className="alert-dialog_image">
                    <GeneralAlertImg />
                </Box>
                <Box className="alert-dialog__content">
                    <Typography className="alert-dialog__title">{title}</Typography>
                    <Typography className="alert-dialog__description">{description}</Typography>
                </Box>
                <Button variant="contained" onClick={onButtonClick}>
                    {buttonText}
                </Button>
            </Box>
        </Dialog>
    );
};

export default AlertDialog;
